import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";
import { useAuth } from "./AuthContext";

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);

  const refresh = useCallback(async () => {
    if (!user) { setItems([]); return; }
    try {
      const r = await api.get("/cart");
      setItems(r.data.items || []);
    } catch (err) {
      console.warn("Failed to load cart:", err?.response?.status || err?.message);
    }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  const add = async (product_id, quantity = 1) => {
    await api.post("/cart/add", { product_id, quantity });
    await refresh();
    setOpen(true);
  };

  const update = async (product_id, quantity) => {
    await api.post("/cart/update", { product_id, quantity });
    await refresh();
  };

  const clear = async () => {
    await api.delete("/cart/clear");
    await refresh();
  };

  const total = items.reduce((s, it) => {
    const p = it.product;
    const unit = p.is_promo && p.promo_price ? p.promo_price : p.price;
    return s + unit * it.quantity;
  }, 0);

  const count = items.reduce((s, it) => s + it.quantity, 0);

  return (
    <CartContext.Provider value={{ items, open, setOpen, add, update, clear, refresh, total, count }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
